import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { SessionLimitItemModule } from "@obg/mat.ui.common";
import { DialogLayoutModule, MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { CommonValidationRendererModule, InputInformationModule } from "@obg/ngx.ui.common";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { ArgentineSessionLimitContainer } from "./argentine/argentine-session-limit.container";
import { HgcSessionLimitContainer } from "./hgc/hgc-session-limit.container";
import { KsaSessionLimitContainer } from "./ksa/ksa-session-limit.container";
import { MultiSessionLimitConfirmationComponent } from "./multi-session-limit/multi-session-limit-confirmation-dialog/multi-session-limit-confirmation.component";
import { MultiSessionLimitContainer } from "./multi-session-limit/multi-session-limit.container";
import { SgaSessionLimitDialogContainer } from "./sga/session-limit-dialog/sga-session-limit-dialog.container";
import { SgaSessonLimitContainer } from "./sga/sga-session-limit.container";
import { ZhhSessionLimitContainer } from "./zhh/zhh-session-limit.container";

const DIRECTIVES: any[] = [
	HgcSessionLimitContainer,
	SgaSessionLimitDialogContainer,
	SgaSessonLimitContainer,
	ArgentineSessionLimitContainer,
	KsaSessionLimitContainer,
	ZhhSessionLimitContainer,
	MultiSessionLimitContainer,
	MultiSessionLimitConfirmationComponent,
];

@NgModule({
	imports: [
		CoreUiModule,
		MatInputModule,
		MatCardModule,
		MatRadioModule,
		GlobalUiModule,
		GlobalModule,
		MatFormFieldModule,
		CommonModule,
		CoreContentModule,
		CoreModule,
		MatCoreModule,
		MatButtonModule,
		MatProgressSpinnerModule,
		ReactiveFormsModule,
		DialogLayoutModule,
		SessionLimitItemModule,
		CommonValidationRendererModule,
		InputInformationModule,
		MatIconModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class SessionLimitModule {
	constructor(resolver: ComponentFactoryResolver, componentFactoryService: ComponentFactoryService) {
		componentFactoryService.registerLazyLoadedResolver(resolver, SgaSessionLimitDialogContainer);
	}
}
